module.exports = __webpack_public_path__ + "static/media/CTLA_7-286w.522d739f.webp";